import I18n from 'I18n';
import { useMemo } from 'react';
import ListingLibBUSelect from 'framework-listing-lib/filters/ListingLibBUSelect';
import ListingLibTeamsSelect from 'framework-listing-lib/filters/ListingLibTeamsSelect';
import { ListingLibFiltersBar } from 'framework-listing-lib/filters/ListingLibFiltersBar';
import { BU_PROPERTY_NAME } from 'framework-listing-lib/constants/businessUnits';
import { CONTENT_TEAM_ASSIGNMENT } from 'FormsUI/constants/Scopes';
import useSyncQuickFiltersWithQueryString from 'FormsUI/components/dashboard/frameworkTable/hooks/useSyncQuickFiltersWithQueryString';
import { PROPERTIES, MANUALLY_EXCLUDED_COLUMNS } from 'FormsUI/components/dashboard/frameworkTable/constants';
import FormTypeFilter from 'FormsUI/components/dashboard/frameworkTable/Filters/FormTypeFilter';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EXTERNAL_QUICK_FILTER_PROPERTY_NAMES = [PROPERTIES.FORM_TYPE, PROPERTIES.HUBSPOT_ALL_TEAM_IDS, BU_PROPERTY_NAME];
const Filters = ({
  hasBusinessUnitAccess
}) => {
  useSyncQuickFiltersWithQueryString();
  const propertyOverride = useMemo(() => ({
    propertyMap: Object.assign({}, MANUALLY_EXCLUDED_COLUMNS.reduce((acc, excludedColumn) => Object.assign({}, acc, {
      [excludedColumn]: {
        hidden: true
      }
    }), {}), {
      [PROPERTIES.CREATED_BY_USER_ID]: {
        label: I18n.text('dashboard.frameworkTable.columns.createdByUserId.label')
      },
      [PROPERTIES.UPDATED_BY_USER_ID]: {
        label: I18n.text('dashboard.frameworkTable.columns.updatedByUserId.label')
      },
      [PROPERTIES.UPDATED_AT]: {
        label: I18n.text('dashboard.frameworkTable.columns.updatedAt.label')
      },
      [PROPERTIES.FORM_ID]: {
        hidden: true
      },
      [PROPERTIES.BUSINESS_UNIT_IDS]: {
        hidden: true
      }
    })
  }), []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [hasBusinessUnitAccess && /*#__PURE__*/_jsx(ListingLibBUSelect, {
      use: "button"
    }), /*#__PURE__*/_jsx(ListingLibTeamsSelect, {
      use: "button",
      viewAllAssetsScope: CONTENT_TEAM_ASSIGNMENT,
      viewTeamOwnedAssetsScope: CONTENT_TEAM_ASSIGNMENT
    }), /*#__PURE__*/_jsx(FormTypeFilter, {}), /*#__PURE__*/_jsx(ListingLibFiltersBar, {
      propertyOverride: propertyOverride,
      externalQuickFilterPropertyNames: EXTERNAL_QUICK_FILTER_PROPERTY_NAMES
    })]
  });
};
export default Filters;